<div class="container">
  <div class="imageContainer" *ngIf="image; else noImage">
    <img [src]="'data:image/png;base64,' + image" alt="Summary Image" />
  </div>
  <ng-template #noImage>
    <p>Congrats</p>
  </ng-template>

  <div class="share-container">
    <div class="share-question-btn">
      <!-- <h4 class="share-question-btn-title">Share Question</h4> -->
      <!-- <img class="question-image-img" src="assets/books/question-image.jpg" alt="Question Image"> -->
      <h4 class="share-question-btn-text">Share with friends</h4>
      <div class="share-question-btn-icon">
        <a href="https://www.facebook.com/sharer/" target="_blank"><i class="fab fa-facebook"
            style="color: #1877F2;"></i></a>
        <a href="https://wa.me/?text" target="_blank"><i class="fab fa-whatsapp" style="color: #25D366;"></i></a>
        <a href="https://www.twitter.com/intent/" target="_blank"><i class="fab fa-twitter"
            style="color: #1DA1F2;"></i></a>
        <a href="https://www.instagram.com/intent/" target="_blank"><i class="fab fa-instagram"
            style="color: #E1306C;"></i></a>
        <a href="https://www.linkedin.com/shareArticle?mini=true&url=" target="_blank"><i class="fab fa-linkedin"
            style="color: #0077B5;"></i></a>
      </div>
    </div>
  </div>
</div>